import { ErrorHandler, Injectable } from '@angular/core';
import {
  isChunkLoadError,
  reloadPageForStaleChunks,
} from './chunk-load-error.util';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (isChunkLoadError(error) && reloadPageForStaleChunks()) {
      return;
    }

    console.error(error);
  }
}
